import React from 'react';
import PropTypes from 'prop-types'; // For prop validation
import './TitleComponent.css';

const TitleComponent = ({ title }) => {
  return (
    <div className="title-component">
      {title}
    </div>
  );
};

// Prop validation (optional but a good practice)
TitleComponent.propTypes = {
  title: PropTypes.string.isRequired,
};

export default TitleComponent;
